import React, {useContext} from 'react'
import classes from './Feedbacks.module.scss'
import Kamal from './images/Kamal.png'
import Elbrus from './images/elbrus.png'
import Gunay from './images/Gunay.png'

import { LanguageContext } from '../../containers/Language'


const Feedbacks = () => {

    const {dictionary} = useContext(LanguageContext);

    return (
        <div className={classes.feedback}>
            <div className="container">
                <h3 dangerouslySetInnerHTML={{__html: dictionary.CUSTOMERS_FEEDBACK}} className={`text-center ${classes.title}`}></h3>

               <div className={classes.feedbackList}>
                    <div className={classes.feedbackItem}>

                        <div className={classes.customerImage}>
                            <img src={Kamal} alt={dictionary.KAMAL} />
                        </div>
                        
                        <div className={classes.customerInfo}>
                            <h5 dangerouslySetInnerHTML={{__html: dictionary.KAMAL}} className='mb-0'></h5>
                            <p className='mb-0'>Caspian Drilling Company</p>
                        </div>
                        
                        <p dangerouslySetInnerHTML={{__html: dictionary.KAMAL_FEEDBACK}} className={`mb-0 ${classes.feedbackText}`}></p>
                    </div>

                    <div className={classes.feedbackItem}>
                        <div className={classes.customerImage}>
                            <img src={Elbrus} alt={dictionary.ELBRUS} />
                        </div>
                        
                        <div className={classes.customerInfo}>
                            <h5 dangerouslySetInnerHTML={{__html: dictionary.ELBRUS}} className='mb-0'></h5>
                            <p className='mb-0'>PMD / Expressbank</p>
                        </div>
                        
                        <p dangerouslySetInnerHTML={{__html: dictionary.ELBRUS_FEEDBACK}} className={`mb-0 ${classes.feedbackText}`}>
                        </p>
                    </div>

                    <div className={classes.feedbackItem}>
                        <div className={classes.customerImage}>
                            <img src={Gunay} alt={dictionary.GUNAY} />
                        </div>
                        
                        <div className={classes.customerInfo}>
                            <h5 dangerouslySetInnerHTML={{__html: dictionary.GUNAY}} className='mb-0'></h5>
                            <p className='mb-0'>Azercell</p>
                        </div>
                        
                        <p dangerouslySetInnerHTML={{__html: dictionary.GUNAY_FEEDBACK}} className={`mb-0 ${classes.feedbackText}`}>
                        </p>
                    </div>
               </div>
            </div>
        </div>
    )
}

export default Feedbacks
